import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RationGrp = ({ idGroupe,nbGroupe,token }) => {
    const ip = process.env.REACT_APP_IP;
    const [rationGroupe, setRationGroupe] = useState(0);
    const [idVar, setIdVar] = useState(0);
    const [isDivided, setIsDivided] = useState(false); // Nouvel état pour le switch

    const fetchRation = async () => {
        try {
            const response = await axios.get(`${ip}/ration/${idGroupe}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                }
            });
            setRationGroupe(response.data[0].valeur);
            setIdVar(response.data[0].idVariable);
        } catch (error) {
            console.error('Une erreur s\'est produite lors de la récupération de la ration :', error);
        }
    };

    const handleChangeRation = async (value) => {
        setRationGroupe(value);
        try {
            const response = await axios.put(`${ip}/ration/${idVar}`, { valeur: value },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
        } catch (error) {
            console.error('Une erreur s\'est produite lors de la mise à jour des données :', error);
        }
    };

    const incrementRation = () => {
        const incrementValue = isDivided ? nbGroupe : 1;
        const newValue = rationGroupe + incrementValue;
        handleChangeRation(newValue);
    };

    const decrementRation = () => {
        const decrementValue = isDivided ? nbGroupe : 1;
        const newValue = rationGroupe - decrementValue;
        handleChangeRation(newValue);
    };

    const handleInputChange = (e) => {
        const newValue = parseInt(e.target.value, 10);
        if (!isNaN(newValue)) {
            setRationGroupe(newValue);
        }
    };

    const handleBlur = () => {
        handleChangeRation(rationGroupe);
    };

    const toggleSwitch = () => {
        setIsDivided(!isDivided);
    };

    useEffect(() => {
        fetchRation();
    }, [idGroupe]);
    return (
        <div className="container-ration">
            <div>
                <button className="buttonRation" onClick={decrementRation}>-</button>
                <input
                    type="number"
                    className="input-ration"
                    value={isDivided ? rationGroupe / nbGroupe : rationGroupe}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                />
                <button className="buttonRation" onClick={incrementRation}>+</button>
            </div>
            <div className="checkbox_item citem_3">
                <label className="checkbox_wrap">
                    <input type="checkbox"
                        name="checkbox"
                        className="checkbox_inp"
                        checked={isDivided}
                        onChange={toggleSwitch}
                    />
                    <span className="checkbox_mark"></span>
                </label>
            </div>
        </div>
    );
};

export default RationGrp;
